import { Grid, IconButton } from "@material-ui/core";
import Drawer from "@material-ui/core/Drawer";
import Hidden from "@material-ui/core/Hidden";
import { makeStyles } from "@material-ui/core/styles";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import { setShowMenu } from "actions/user";
import { logOut } from "apis/index";
import {
  drawerWidth,
  transition,
} from "assets/jss/material-dashboard-react.js";
import classNames from "classnames";
import { get } from "lodash";
import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useHistory, useLocation, matchPath } from "react-router-dom";
import {
  getGalleryName,
  getPhotosByGallery,
  setDrawWidth,
} from "../../actions/gallery";
import LogoImg from "../../assets/images/logo/blue_logo.png";
import { setEditingGallery } from "../../actions/gallery";
import {
  getLoggedInUserDisplayName,
  loggedInUser,
} from "../../v2_actions/auth";
const minDrawerWidth = 260;
const maxDrawerWidth = 1000;

const useStyles = makeStyles((theme) => ({
  drawerPaper: {
    position: "fixed",
    top: "0",
    height: "100%",
    bottom: "0",
    overflow: "hidden",
    flexShrink: 0,
    zIndex: 9999,
    background: "#ffffff",
    overflowScrolling: "auto",
    borderTop: "none",
    width: drawerWidth,
    borderRight: "1px solid #d6e2ef",
    [theme.breakpoints.up("md")]: {
      width: `calc(${drawerWidth}px - 30px)`,
      position: "fixed",
      height: "100%",
    },
    [theme.breakpoints.down("sm")]: {
      width: `calc(${drawerWidth}px - 30px)`,
      position: "",
      display: "block",
      top: "0",
      height: "100vh",
      right: "0",
      left: "auto",
      zIndex: "1032",
      visibility: "visible",
      overflowY: "visible",
      borderTop: "none",
      textAlign: "left",
      paddingRight: "0px",
      paddingLeft: "0",
      transform: `translate3d(${drawerWidth}px, 0, 0)`,
      ...transition,
    },
  },
  subMenu: {
    display: "flex",
    paddingLeft: 15,
    paddingBottom: 3,
    fontSize: 18,
    fontWeight: "500",
    cursor: "pointer",
  },
  sidebarWrapper: {
    position: "relative",
    height: "auto",
    overflow: "auto",
    zIndex: "4",
    overflowScrolling: "touch",
    padding: "0 14px",
    fontFamily: "'Open Sans', system-ui, -apple-system, Segoe UI, sans-serif",
    fontSize: "16px",
    "& *": {
      fontFamily: "inherit",
    },
  },
  dragger: {
    width: "0",
    cursor: "ew-resize",
    padding: "6px 0 0",
    borderTop: "1px solid #ddd",
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    zIndex: 100,
  },
  logoContainer: {
    position: "fixed",
    top: "18px",
    left: "22px",
    zIndex: 10000,
  },
  logo_img: {
    width: "170px",
    height: "34px",
  },
  wrapper: {
    marginRight: "10px",
  },
  opaque: {
    opacity: "0.30 !important",
    pointerEvents: "none",
  },
  navList: {
    display: "flex",
    flexDirection: "column",
    gap: "1px",
    listStyle: "none",
    padding: 0,
    margin: 0,
  },
  navGroup: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    padding: "9px 10px 5px",
    fontSize: "16px !important",
    fontWeight: 700,
    color: "#0b3556",
    lineHeight: 1.2,
    "& span": {
      fontSize: "16px !important",
    },
  },
  navGroupIcon: {
    width: "22px",
    height: "22px",
    color: "#7a7a76",
    flexShrink: 0,
  },
  subList: {
    display: "flex",
    flexDirection: "column",
    gap: "1px",
    padding: "2px 0 4px 30px",
    position: "relative",
    "&::before": {
      content: '""',
      position: "absolute",
      left: "19px",
      top: "4px",
      bottom: "4px",
      width: "1px",
      background: "#d6e2ef",
    },
  },
  subItem: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    padding: "7px 10px",
    borderRadius: "6px",
    fontSize: "16px !important",
    fontWeight: 500,
    color: "#4a4a48",
    "& span": {
      fontSize: "16px !important",
    },
    textDecoration: "none",
    transition: "background 0.12s, color 0.12s",
    "&:hover": {
      background: "#f4f8fd",
      color: "#0b3556",
    },
    "&:hover $subDot": {
      background: "#3a86d8",
    },
  },
  subItemActive: {
    background: "#e7f0fa",
    color: "#0b3556",
    fontWeight: 700,
    "& $subDot": {
      background: "#3a86d8",
    },
  },
  subDot: {
    width: "5px",
    height: "5px",
    borderRadius: "50%",
    background: "#7a7a76",
    flexShrink: 0,
    transition: "background 0.12s",
  },
  navItem: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    gap: "10px",
    padding: "9px 10px",
    borderRadius: "8px",
    fontSize: "16px !important",
    fontWeight: 600,
    color: "#0b3556",
    lineHeight: 1.2,
    "& span": {
      fontSize: "16px !important",
    },
    position: "relative",
    textDecoration: "none",
    transition: "background 0.12s, color 0.12s",
    "&:hover": {
      background: "#f4f8fd",
      color: "#0b3556",
    },
    "&:hover $navItemIcon": {
      color: "#0b3556",
    },
  },
  navItemActive: {
    background: "#e7f0fa",
    color: "#0b3556",
    "&::before": {
      content: '""',
      position: "absolute",
      left: "-14px",
      top: "8px",
      bottom: "8px",
      width: "3px",
      borderRadius: "0 3px 3px 0",
      background: "#3a86d8",
    },
    "& $navItemIcon": {
      color: "#3a86d8",
    },
  },
  navItemIcon: {
    width: "22px",
    height: "22px",
    color: "#7a7a76",
    flexShrink: 0,
    transition: "color 0.12s",
  },
}));

const isGroupHeader = (route) => route.showable && route.path === "#";

const buildMenuStructure = (routes) => {
  const items = [];
  let currentGroup = null;
  routes.forEach((route) => {
    if (isGroupHeader(route)) {
      currentGroup = { type: "group", header: route, children: [] };
      items.push(currentGroup);
    } else if (route.showable && route.groupChild && currentGroup) {
      currentGroup.children.push(route);
    } else if (route.showable) {
      currentGroup = null;
      items.push({ type: "item", route });
    }
  });
  return items;
};

export const ContextMenuSidebar = ({ color, routes }) => {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const displayName = getLoggedInUserDisplayName();
  const is_staff = get(loggedInUser(), "is_staff");
  const drawerWidth = useSelector((state) => state.gallery.drawWidth);
  const showMenu = useSelector((state) => state.user.showMenu);
  const location = useLocation();
  const isLoading = useSelector((state) => state.ui.isLoading);

  const onUploadNewGallery = () => {
    dispatch(setEditingGallery({}));
  };

  function signOut() {
    dispatch(getPhotosByGallery([]));
    dispatch(getGalleryName(null, null));
    logOut();
    history.push(`/photographer/login`);
  }

  const handleMouseDown = (e) => {
    document.addEventListener("mouseup", handleMouseUp, true);
    document.addEventListener("mousemove", handleMouseMove, true);
  };

  const handleMouseUp = () => {
    document.removeEventListener("mouseup", handleMouseUp, true);
    document.removeEventListener("mousemove", handleMouseMove, true);
  };

  const handleMouseMove = useCallback((e) => {
    const newWidth = e.clientX - document.body.offsetLeft;
    if (newWidth > minDrawerWidth && newWidth < maxDrawerWidth) {
      dispatch(setDrawWidth(newWidth));
    }
    // eslint-disable-next-line
  }, []);

  const isActive = (path) => {
    return !!matchPath(location.pathname, { path, exact: true, strict: false });
  };

  const handleItemClick = (prop) => {
    dispatch(setShowMenu(!showMenu));
    if (prop?.isCreate) onUploadNewGallery();
  };

  const renderSubItem = (prop, ind) => {
    const active = isActive(prop.path);
    const itemClass = `${classes.subItem} ${active ? classes.subItemActive : ""}`;

    if (prop.openLinkInNewBrowserTab) {
      return (
        <a
          key={`sub-${ind}`}
          href={prop.path}
          target="_blank"
          rel="noreferrer"
          className={itemClass}
          onClick={() => handleItemClick(prop)}
        >
          <span className={classes.subDot} />
          <span>{prop.name}</span>
        </a>
      );
    }

    return (
      <NavLink
        key={`sub-${ind}`}
        to={prop.path}
        className={itemClass}
        onClick={() => handleItemClick(prop)}
      >
        <span className={classes.subDot} />
        <span>{prop.name}</span>
      </NavLink>
    );
  };

  const renderNavItem = (prop, ind) => {
    const active = isActive(prop.path);
    const itemClass = `${classes.navItem} ${active ? classes.navItemActive : ""}`;

    if (prop.openLinkInNewBrowserTab) {
      return (
        <a
          key={`nav-${ind}`}
          href={prop.path}
          target="_blank"
          rel="noreferrer"
          className={itemClass}
          onClick={() => handleItemClick(prop)}
        >
          {prop.icon && <prop.icon className={classes.navItemIcon} />}
          <span>{prop.name}</span>
        </a>
      );
    }

    return (
      <NavLink
        key={`nav-${ind}`}
        to={prop.path}
        className={itemClass}
        onClick={() => handleItemClick(prop)}
      >
        {prop.icon && <prop.icon className={classes.navItemIcon} />}
        <span>{prop.name}</span>
      </NavLink>
    );
  };

  const menuStructure = buildMenuStructure(routes);

  const links = (
    <div className={classes.navList}>
      {menuStructure.map((entry, idx) => {
        const prevEntry = menuStructure[idx - 1];
        const needsTopGap = prevEntry && prevEntry.type === "group" && entry.type !== "group";
        if (entry.type === "group") {
          return (
            <div key={`group-${idx}`}>
              <div className={classes.navGroup}>
                {entry.header.icon && <entry.header.icon className={classes.navGroupIcon} />}
                <span>{entry.header.name}</span>
              </div>
              <div className={classes.subList}>
                {entry.children.map((child, ci) => renderSubItem(child, `${idx}-${ci}`))}
              </div>
            </div>
          );
        }
        return <div key={`nw-${idx}`} style={needsTopGap ? { marginTop: 6 } : undefined}>{renderNavItem(entry.route, idx)}</div>;
      })}
    </div>
  );

  return (
    <div className={`${classes.wrapper} ${isLoading && classes.opaque}`}>
      <Hidden mdUp>
        <Drawer
          variant="temporary"
          anchor={"right"}
          open={showMenu}
          classes={{
            paper: classNames(classes.drawerPaper),
          }}
        >
          {is_staff === "true" && (
            <div
              className={classes.subMenu}
              style={{ flexDirection: "column" }}
            >
              <div
                style={{ display: "flex" }}
                onClick={() => history.push(`/photographer/editdetails`)}
              >
                <AccountCircleIcon />
                <span>{displayName}</span>
              </div>
              <div style={{ paddingLeft: 38 }} onClick={() => signOut()}>
                <span>Sign Out</span>
              </div>
            </div>
          )}

          <div className={classes.sidebarWrapper} key="navlink1">
            {links}
          </div>
        </Drawer>
      </Hidden>
      <Hidden smDown>
        <div
          classes={{
            paper: classNames(classes.drawerPaper),
          }}
        >
          <div
            onMouseDown={(e) => handleMouseDown(e)}
            className={classes.dragger}
          />
          {displayName && (
            <div className={classes.logoContainer}>
              <IconButton onClick={() => dispatch(setShowMenu(true))}>
                <img src={LogoImg} alt="/" className={classes.logo_img} />
              </IconButton>
            </div>
          )}
          <div className={classes.sidebarWrapper} key="navlink1">
            {links}
          </div>
        </div>
      </Hidden>
    </div>
  );
};
